import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_DELETE,
    MASTER_DATA_REMARK_INSERT,
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class Escalation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Deskripsi Remark",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, escalationDataSelectedEdit: data, escalation: data.description })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, escalationDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            escalationOptions: {
                data: [
                    {
                        label: "Eskalasi ke CS Lain (Assign CS oleh Sistem)",
                        value: "escalate-by-system",
                        category: "escalate-by-system"
                    },
                    {
                        label: "Eskalasi ke CS Lain (Assign CS oleh Super User)",
                        value: "escalate-by-super-user",
                        category: "escalate-by-superUser"
                    },
                    {
                        label: "Eskalasi ke Pihak Ketiga",
                        value: "escalate-bug-external",
                        category: "escalate-bug-external"
                    },
                ],
                value: [],
            },
            disableButtonAddAndSave: true,
            listEscalation: [],
            escalation: '',
            escalationDataSelectedEdit: {},
            escalationDataSelectedDelete: {},
            showAddModal: false,
            showEditModal: false,
            showWarningEscalation: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateEscalation(this.state.escalationOptions.value.value);
                this.getListEscalation(this.state.escalationOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateEscalation(this.state.escalationOptions.value.value);
                this.getListEscalation(this.state.escalationOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChangeEscalation = e => {
        this.setState({
            escalationOptions: { ...this.state.escalationOptions, value: e },
            disableButtonAddAndSave: false
        }, () => {
            this.getInitiateEscalation(this.state.escalationOptions.value.value);
            this.getListEscalation(this.state.escalationOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        });
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getInitiateEscalation = escalationType => {
        API_REMARK.getInitiateEscalation(escalationType, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListEscalation = (escalationType, current, pageSize) => {
        API_REMARK.getListEscalation(escalationType, current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listEscalation: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningEscalation: false,
            escalation: ''
        });
    }

    handleConfirmAddEscalation = () => {
        if (!this.state.escalation) return this.setState({ showWarningEscalation: true });
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddEscalation = () => {
        const data = {
            description: this.state.escalation,
            category: this.state.escalationOptions.value.category
        }

        API_REMARK.postDataRemark(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        escalation: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddEscalation = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateEscalation(this.state.escalationOptions.value.value);
            this.getListEscalation(this.state.escalationOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditEscalation = () => {
        if (!this.state.escalation) return this.setState({ showWarningEscalation: true });
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditEscalation = () => {
        const escalationId = this.state.escalationDataSelectedEdit.id;
        const data = {
            remark: this.state.escalationDataSelectedEdit.remark,
            description: this.state.escalation,
            category: this.state.escalationOptions.value.category,
            category_id: this.state.escalationDataSelectedEdit.category_id,
            updated_at: this.state.escalationDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(escalationId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        escalation: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditEscalation = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateEscalation(this.state.escalationOptions.value.value);
            this.getListEscalation(this.state.escalationOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeleteEscalation = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const escalationId = this.state.escalationDataSelectedDelete.id;
        const data = {
            remark: this.state.escalationDataSelectedDelete.remark,
            category: this.state.escalationOptions.value.category,
            updated_at: this.state.escalationDataSelectedDelete.updated_at
        }
        API_REMARK.deleteDataRemark(escalationId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteEscalation = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateEscalation(this.state.escalationOptions.value.value);
            this.getListEscalation(this.state.escalationOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="Eskalasi"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                {/* Filter Escalation */}
                                <div className="w-1/3 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Opsi Eskalasi</p>
                                    </div>
                                    <Select
                                        inputId="ddsescalationoptions"
                                        name="escalationOptions"
                                        options={this.state.escalationOptions.data}
                                        value={this.state.escalationOptions.value}
                                        placeholder="Pilih Opsi Eskalasi"
                                        components={{ IndicatorSeparator: () => null }}
                                        className="w-full"
                                        onChange={this.handleChangeEscalation}
                                    />
                                </div>

                                {/* Add Escalation Button */}
                                <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_INSERT]} userPermission={this.props.userDetail.permissions}>
                                    <button id="btnaddescalation" onClick={() => this.setState({ showAddModal: true })} className={`flex items-center text-white py-2 px-6 rounded-md ${this.state.disableButtonAddAndSave ? "bg-gray-500 cursor-default" : "bg-olddarkblue cursor-pointer"}`} disabled={this.state.disableButtonAddAndSave}>
                                        <IconAddTransparent />
                                        <span className="ml-2">Eskalasi</span>
                                    </button>
                                </CheckPermissionComponent>

                                {/* Table Escalation */}
                                <div className={this.state.escalationOptions.value.value ? "block" : "hidden"}>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listEscalation}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add Escalation Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah Eskalasi</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlescalationadd"
                                        className="form-control resize-none"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="escalation"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningEscalation: false });
                                        }}
                                        minLength="3"
                                        maxLength="50"
                                        autoComplete="off"
                                        value={this.state.escalation}
                                    />
                                    {this.state.showWarningEscalation && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddescalation" onClick={this.handleConfirmAddEscalation}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit Escalation Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Eskalasi</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlescalationedit"
                                        className="form-control resize-none"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="escalation"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningEscalation: false });
                                        }}
                                        minLength="3"
                                        maxLength="50"
                                        autoComplete="off"
                                        value={this.state.escalation}
                                    />
                                    {this.state.showWarningEscalation && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditescalation" onClick={this.handleConfirmEditEscalation}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan Eskalasi" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddEscalation} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddEscalation} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Eskalasi" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditEscalation} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditEscalation} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus Eskalasi" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, escalationDataSelectedDelete: {} })} submit={this.handleDeleteEscalation} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteEscalation} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Escalation);